<template>
  <div class="content-container">
    <search-component @onSearch="onDisplayPriceList" />
    <div class="das-form-container">
      <div class="das-form-group">
        <div class="das-form-group-title">Loại giá áp dụng</div>
        <hr />
        <div class="das-form-row">
          <div class="das-form-col col-4">
            <validation-provider
              rules="required"
              :name="$t('validator.priceType')"
            >
              <div class="das-form-input">
                <div class="label">Loại giá</div>
                <el-select v-model="dailyPriceItem.price_type" placeholder="">
                  <el-option
                    v-for="item in priceTypeOptions"
                    :key="item.id"
                    :label="item.code"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </validation-provider>
          </div>
          <div class="das-form-col col-4">
            <validation-provider
              rules="required"
              name="Khoảng thời gian của loại giá"
            >
              <input
                v-model="dailyPriceItem.start_date"
                style="display: none"
              />
            </validation-provider>
            <validation-provider
              rules="required"
              name="Khoảng thời gian của loại giá"
            >
              <input v-model="dailyPriceItem.end_date" style="display: none" />
            </validation-provider>
            <div class="das-form-input">
              <div class="label">Ngày</div>
              <CalendarRange
                v-model="appliedPriceCodePeriod"
                style="display: block"
                mode="date"
              />
            </div>
          </div>
        </div>
        <div class="das-form-row">
          <div class="das-form-col col-12">
            <div class="checkbox-container">
              <div class="checkbox-wrap">
                <input
                  id="cpSpdTp4"
                  type="checkbox"
                  :checked="allDayApplied"
                  @change="changeAppliedDay(0)"
                />
                <label for="cpSpdTp4">Chọn tất cả</label>
              </div>
              <div class="checkbox-wrap">
                <input
                  id="cpSpdTp5"
                  type="checkbox"
                  :checked="dailyPriceItem.weekday.includes(8)"
                  @change="changeAppliedDay(8)"
                />
                <label for="cpSpdTp5">Chủ nhật</label>
              </div>
              <div class="checkbox-wrap">
                <input
                  id="cpSpdTp6"
                  type="checkbox"
                  :checked="dailyPriceItem.weekday.includes(2)"
                  @change="changeAppliedDay(2)"
                />
                <label for="cpSpdTp6">Thứ hai</label>
              </div>
              <div class="checkbox-wrap">
                <input
                  id="cpSpdTp7"
                  type="checkbox"
                  :checked="dailyPriceItem.weekday.includes(3)"
                  @change="changeAppliedDay(3)"
                />
                <label for="cpSpdTp7">Thứ ba</label>
              </div>
              <div class="checkbox-wrap">
                <input
                  id="cpSpdTp8"
                  type="checkbox"
                  :checked="dailyPriceItem.weekday.includes(4)"
                  @change="changeAppliedDay(4)"
                />
                <label for="cpSpdTp8">Thứ tư</label>
              </div>
              <div class="checkbox-wrap">
                <input
                  id="cpSpdTp9"
                  type="checkbox"
                  :checked="dailyPriceItem.weekday.includes(5)"
                  @change="changeAppliedDay(5)"
                />
                <label for="cpSpdTp9">Thứ năm</label>
              </div>
              <div class="checkbox-wrap">
                <input
                  id="cpSpdTp10"
                  type="checkbox"
                  :checked="dailyPriceItem.weekday.includes(6)"
                  @change="changeAppliedDay(6)"
                />
                <label for="cpSpdTp10">Thứ sáu</label>
              </div>
              <div class="checkbox-wrap">
                <input
                  id="cpSpdTp11"
                  type="checkbox"
                  :checked="dailyPriceItem.weekday.includes(7)"
                  @change="changeAppliedDay(7)"
                />
                <label for="cpSpdTp11">Thứ bảy</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Main table -->
    <div class="das-info-title">Danh sách giá phòng theo ngày</div>
    <hr />
    <div class="grid-scroll mt-10" style="height: 400px">
      <GridVx
        ref="agGrid"
        v-loading="mainTableLoading"
        :context="context"
        :columns="columns"
        :rows="rows"
        dom-layout="scroll"
        class="agGrid"
      />
    </div>
    <div class="button-containers">
      <button
        :disabled="!updatePermit"
        class="btn primary small"
        @click="updateDailyPrice"
      >
        {{ $t('button.update') }}
      </button>
      <button class="btn primary small" @click="openPriceTypeDialog">
        {{ $t('button.priceTypeUpdate') }}
      </button>
    </div>
    <el-dialog
      title="Thông báo"
      :visible.sync="dialogNotiVisible"
      :close-on-click-modal="false"
      width="70%"
    >
      <div>
        Các đặt phòng dưới đây đang sử dụng mã giá này và có thể bị ảnh hưởng
        khi bạn thay đổi giá của mã giá!
      </div>
      <div style="font-weight: bold; margin: 10px 0">DANH SÁCH ĐẶT PHÒNG</div>
      <!-- Notice Table 1 -->
      <div style="height: 350px">
        <GridVx
          ref="agGrid1"
          row-selection="single"
          dom-layout="scroll"
          :columns="bookingListColumns"
          :rows="bookingListRows"
          class="agGrid"
        />
      </div>
      <div style="font-weight: bold; margin: 10px 0">DANH SÁCH ĐOÀN</div>
      <!-- Notice Table 2 -->
      <div style="height: 350px">
        <GridVx
          ref="agGrid2"
          row-selection="single"
          dom-layout="scroll"
          :columns="groupsListColumns"
          :rows="groupsListRows"
          class="agGrid"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary">Xuất excel</el-button>
        <el-button type="danger" @click="dialogNotiVisible = false"
          >Đóng</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :title="$t('dialog.configPriceType')"
      :visible.sync="dialogPriceConfigVisible"
      :close-on-click-modal="false"
      width="1050px"
    >
      <div class="das-layout gap-10">
        <div class="l-w-40">
          <div class="border-box mb-10">
            <div class="das-info-title m-0">Thông tin loại giá</div>
            <hr />
            <!-- Config Table 1 (Left) -->
            <div style="height: 250px">
              <GridVx
                ref="agGridPriceCode"
                :context="context"
                :auto-size-cell="true"
                :auto-select-first-row="false"
                dom-layout="scroll"
                :columns="configTable1Columns"
                :rows="priceTypeOptions"
                class="agGrid"
                @rowClicked="onPriceCodeRowClicked"
              />
            </div>
            <!-- <validation-observer ref="formValidator1">
              <div class="das-form-container" style="margin: 10px 0">
                <div class="das-form-group">
                  <div class="das-form-row align-end justify-space-between m-0">
                    <div class="das-form-col col-8">
                      <validation-provider rules="required|max: 255" name="Mã">
                        <div class="das-form-input">
                          <div class="label required">Mã</div>
                          <input
                            v-model="priceCodeDialogItem.code"
                            type="text"
                            :readonly="!isEditConfig1"
                          />
                        </div>
                      </validation-provider>
                    </div>
                    <div class="das-form-col col-4 justify-center">
                      <button
                        v-if="addConfigCode1Visible"
                        style="width: 100px"
                        class="btn small primary"
                        @click="onAddConfigCode1"
                      >
                        Thêm
                      </button>
                      <button
                        v-else
                        style="width: 100px"
                        class="btn small primary outline"
                        @click="onAddPriceCode"
                      >
                        Lưu
                      </button>
                    </div>
                  </div>
                  <div class="das-form-row align-end justify-space-between m-0">
                    <div class="das-form-col col-8">
                      <validation-provider
                        rules="required|max: 255"
                        name="Mô tả"
                      >
                        <div class="das-form-input">
                          <div class="label required">Mô tả</div>
                          <input v-model="priceCodeDialogItem.desc" type="text" />
                        </div>
                      </validation-provider>
                    </div>
                    <div class="das-form-col col-4 justify-center">
                      <button
                        class="btn small primary"
                        @click="onUpdatePriceCode"
                      >
                        Cập nhật
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </validation-observer> -->
          </div>
          <div class="button-containers">
            <button
              :disabled="!isPriceCodeRowSelected"
              class="btn primary small"
              @click="openEditPriceCodeDialog"
            >
              Sửa loại giá
            </button>
            <button class="btn primary small" @click="openAddPriceCodeDialog">
              Thêm loại giá
            </button>
          </div>
        </div>
        <div class="l-w-60">
          <div class="border-box mb-10">
            <div class="das-info-title m-0">Thông tin giá theo giai đoạn</div>
            <hr />
            <div style="height: 250px">
              <GridVx
                ref="agGrid4"
                :context="context"
                dom-layout="scroll"
                :columns="configTable2Columns"
                :rows="configTable2Rows"
                class="agGrid"
                :auto-select-first-row="false"
                @refresh="onRefresh"
                @rowClicked="onPricePerDayRowClicked"
              />
            </div>
            <!-- <validation-observer ref="formValidator2">
              <div class="das-form-container" style="margin: 10px 0">
                <div class="das-form-group">
                  <div class="das-form-row align-end justify-space-between m-0">
                    <div class="das-form-col col-4">
                      <validation-provider rules="required|max: 255" name="Mã">
                        <div class="das-form-input">
                          <div class="label required">Mã</div>
                          <input
                            v-model="pricePerDayDialogItem.code"
                            type="text"
                            :readonly="!isEditConfig1"
                          />
                        </div>
                      </validation-provider>
                    </div>
                    <div class="das-form-col col-4">
                      <validation-provider
                        rules="required|max: 255"
                        name="Thời gian bắt đầu"
                      >
                        <div class="das-form-input">
                          <div class="label required">Từ</div>
                          <SingleCalendar
                            v-model="pricePerDayDialogItem.date_from"
                            class="use-icon"
                            :date-data="pricePerDayDialogItem.date_from"
                            @changeCalendar="onChangeDate3"
                          />
                        </div>
                      </validation-provider>
                    </div>
                    <div class="das-form-col col-4 justify-center">
                      <button
                        v-if="addConfigCode2Visible"
                        class="btn small primary"
                        style="width: 100px"
                        @click="onAddConfigCode2"
                      >
                        Thêm
                      </button>
                      <button
                        v-else
                        class="btn small primary outline"
                        style="width: 100px"
                        @click="onAddPricePerDay"
                      >
                        Lưu
                      </button>
                    </div>
                  </div>
                  <div class="das-form-row align-end justify-space-between m-0">
                    <div class="das-form-col col-4">
                      <validation-provider
                        rules="required|max: 255"
                        name="Mô tả"
                      >
                        <div class="das-form-input">
                          <div class="label required">Mô tả</div>
                          <input v-model="pricePerDayDialogItem.desc" type="text" />
                        </div>
                      </validation-provider>
                    </div>
                    <div class="das-form-col col-4">
                      <validation-provider
                        rules="required|max: 255"
                        name="Thời gian kết thúc"
                      >
                        <div class="das-form-input">
                          <div class="label required">Đến</div>
                          <SingleCalendar
                            v-model="pricePerDayDialogItem.date_to"
                            class="use-icon"
                            :date-data="pricePerDayDialogItem.date_to"
                            @changeCalendar="onChangeDate4"
                          />
                        </div>
                      </validation-provider>
                    </div>
                    <div class="das-form-col col-4 justify-center">
                      <button
                        class="btn small primary"
                        @click="onUpdatePricePerDay"
                      >
                        Cập nhật
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </validation-observer> -->
          </div>
          <div class="button-containers">
            <button
              :disabled="!isPricePerdayRowSelected"
              class="btn primary small"
              @click="openEditPricePerDayDialog"
            >
              Sửa giá theo ngày
            </button>
            <button class="btn primary small" @click="openAddPricePerDayDialog">
              Thêm giá theo ngày
            </button>
          </div>
        </div>
      </div>
      <div class="das-info-title">Thay đổi giá theo ngày</div>
      <hr />
      <!-- Config Table 3 (Bottom) -->
      <div style="height: 300px" class="select__table-wrapper mb-20">
        <GridVx
          ref="agGrid5"
          v-loading="configTable3Loading"
          :context="context"
          :auto-size-cell="true"
          row-selection="single"
          dom-layout="scroll"
          :columns="configTable3Columns"
          :rows="configTable3Rows"
          class="agGrid"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogPriceConfigVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      :title="isEditPriceCode ? 'Sửa loại giá' : 'Thêm loại giá'"
      :visible.sync="priceCodeDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <validation-observer ref="formValidator1">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max: 20" name="Mã">
                  <div class="das-form-input">
                    <div class="label required">Mã</div>
                    <input
                      v-model="priceCodeDialogItem.code"
                      :readonly="isEditPriceCode"
                      type="text"
                    />
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max: 255" name="Mô tả">
                  <div class="das-form-input">
                    <div class="label required">Mô tả</div>
                    <textarea v-model="priceCodeDialogItem.desc" :rows="3" />
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="priceCodeDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="!isEditPriceCode"
            class="btn primary small"
            @click="onAddPriceCode"
          >
            {{ $t('button.add') }}
          </button>
          <button v-else class="btn primary small" @click="onUpdatePriceCode">
            {{ $t('button.update') }}
          </button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      :title="isEditPricePerDay ? 'Sửa giá theo ngày' : 'Thêm giá theo ngày'"
      :visible.sync="priceCodePerDayDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <validation-observer ref="formValidator2">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max: 20" name="Mã">
                  <div class="das-form-input">
                    <div class="label required">Mã</div>
                    <input
                      v-model="pricePerDayDialogItem.code"
                      :readonly="isEditPricePerDay"
                      type="text"
                    />
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max: 255"
                  name="Thời gian bắt đầu"
                >
                  <div class="das-form-input">
                    <div class="label required">Từ</div>
                    <SingleCalendar
                      v-model="pricePerDayDialogItem.date_from"
                      class="use-icon"
                      :date-data="pricePerDayDialogItem.date_from"
                      @changeCalendar="onChangeDate3"
                    />
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max: 255"
                  name="Thời gian kết thúc"
                >
                  <div class="das-form-input">
                    <div class="label required">Đến</div>
                    <SingleCalendar
                      v-model="pricePerDayDialogItem.date_to"
                      class="use-icon"
                      :date-data="pricePerDayDialogItem.date_to"
                      @changeCalendar="onChangeDate4"
                    />
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max: 255" name="Mô tả">
                  <div class="das-form-input">
                    <div class="label required">Mô tả</div>
                    <textarea v-model="pricePerDayDialogItem.desc" :rows="3" />
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="priceCodePerDayDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="!isEditPricePerDay"
            class="btn primary small"
            @click="onAddPricePerDay"
          >
            {{ $t('button.add') }}
          </button>
          <button v-else class="btn primary small" @click="onUpdatePricePerDay">
            {{ $t('button.modify') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import MultiCalendar from '@/components/ui/MultiCalendar.vue'
import {
  CellRenderTextInput,
  CellRenderCurrencyInput
} from '@/utils/cellRenders.js'
import { Message } from 'element-ui'
import SearchComponent from './components/pricePerdaySearchComponent.vue'
export default {
  components: {
    CellRenderTextInput,
    CellRenderCurrencyInput,
    MultiCalendar,
    SingleCalendar,
    SearchComponent
    // eslint-disable-next-line vue/no-unused-components
  },
  data() {
    return {
      priceCodeId: null,
      priceCodePeriod: {},
      appliedPriceCodePeriod: {},
      isPriceCodeRowSelected: false,
      isPricePerdayRowSelected: false,
      isEditPriceCode: false,
      isEditPricePerDay: false,
      priceCodeDialogVisible: false,
      priceCodePerDayDialogVisible: false,
      addConfigCode1Visible: true,
      addConfigCode2Visible: true,
      allDayApplied: false,
      dailyPriceItem: {
        price_code_id: null,
        price_type: null,
        start_date: null,
        end_date: null,
        weekday: []
      },
      priceTypeOptions: [],
      value: null,
      context: null,
      dialogPriceConfigVisible: false,
      // Loading
      configTable3Loading: false,
      mainTableLoading: false,
      priceCodeDialogItem: {
        code: null,
        desc: null
      },
      pricePerDayDialogItem: {
        code: null,
        desc: null,
        date_from: null,
        date_to: null
      },
      configTable3Rows: [],
      // priceCodeOptions: [],
      priceCodeItem: {
        id: null,
        code: null,
        price_category_id: null,
        price_category_code: null,
        order: null,
        currency_code: null,
        nett: null,
        desc: null,
        startDt: null,
        endDt: null
      },
      // startDate: '',
      // endDate: '',
      // options: [
      //   {
      //     value: 'Option1',
      //     label: 'Option1'
      //   },
      //   {
      //     value: 'Option2',
      //     label: 'Option2'
      //   },
      //   {
      //     value: 'Option3',
      //     label: 'Option3'
      //   },
      //   {
      //     value: 'Option4',
      //     label: 'Option4'
      //   },
      //   {
      //     value: 'Option5',
      //     label: 'Option5'
      //   }
      // ],
      form: [],
      configTable1Columns: [
        {
          headerName: 'Mã',
          field: 'code',
          tooltipField: 'code',
          maxWidth: 130
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          tooltipField: 'desc'
        }
      ],
      configTable2Columns: [
        {
          headerName: 'Mã giai đoạn',
          field: 'code',
          tooltipField: 'code'
        },
        {
          headerName: 'Từ',
          field: 'date_from',
          valueGetter: param => {
            return this.$displayDate(param?.data?.date_from) || null
          }
        },
        {
          headerName: 'Đến',
          field: 'date_to',
          valueGetter: param => {
            return this.$displayDate(param?.data?.date_to) || null
          }
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          tooltipField: 'desc'
        }
      ],
      configTable3Columns: [
        {
          headerName: 'Hạng phòng',
          field: 'room_level_nm',
          maxWidth: 250,
          tooltipField: 'room_level_nm'
        },
        {
          headerName: 'Mô tả',
          field: 'room_level_nm',
          tooltipField: 'room_level_nm'
        },
        {
          headerName: 'Khách',
          field: 'single_guest',
          maxWidth: 250,
          headerClass: 'header-cell-center',
          cellRenderer: 'CellRenderCurrencyInput'
        }
        // {
        //   headerName: 'Khách đôi',
        //   field: 'double_guest',
        //   headerClass: 'header-cell-center',
        //   cellRenderer: 'CellRenderCurrencyInput'
        //   // editable: true
        // },
        // {
        //   headerName: 'Thêm khách',
        //   field: 'extra_guest',
        //   headerClass: 'header-cell-center',
        //   cellRenderer: 'CellRenderCurrencyInput'
        //   // editable: true
        // }
      ],
      configTable2Rows: [],
      bookingListColumns: [
        {
          headerName: 'Trạng thái',
          field: 'age',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Số xác nhận',
          field: 'age',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Số đặt phòng',
          field: 'age',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Tên khách',
          field: 'age',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Công ty, đại lý du lịch',
          field: 'age',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Hạng phòng',
          field: 'age',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Phòng',
          field: 'age',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Ngày đến',
          field: 'age',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Ngày đi',
          field: 'age',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Mã đoàn',
          field: 'age',
          cellClass: 'grid-cell-centered'
        }
      ],
      groupsListColumns: [
        {
          headerName: 'Số xác nhận',
          field: 'age',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Mã đoàn',
          field: 'age',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Tên đoàn',
          field: 'age',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Công ty, đại lý du lịch',
          field: 'age',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Hạng phòng',
          field: 'age',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Từ ngày',
          field: 'age',
          cellClass: 'grid-cell-centered'
        },
        {
          headerName: 'Đến ngày',
          field: 'age',
          cellClass: 'grid-cell-centered'
        }
      ],
      bookingListRows: [],
      groupsListRows: [],
      // titlePopup: '',
      // totalPage: 0,
      // currentPage: 0,
      // isEdit: false,
      isEditConfig1: false,
      // isEditConfig2: false,
      dialogNotiVisible: false,
      // searchParams: {
      //   pageSize: 10,
      //   pageNum: 1,
      //   orderTp: 'ASC'
      // },
      // buildingItem: {
      //   building_no: '',
      //   name: '',
      //   id: null
      // },

      columns: [],
      fixedColumns: [
        {
          headerName: 'Chung',
          headerClass: 'header-cell-center',
          field: '',
          // pinned: 'left',
          children: [
            {
              headerName: 'Ngày',
              field: 'date',
              headerClass: 'header-cell-center',
              cellClass: 'grid-cell-centered',
              valueGetter: param => {
                return this.$displayDate(param?.data?.date) ?? null
              },
              maxWidth: 120,
              pinned: 'left'
            },
            {
              headerName: 'Loại giá',
              field: 'price_type_nm',
              headerClass: 'header-cell-center',
              cellClass: 'grid-cell-centered',
              maxWidth: 120,
              pinned: 'left'
            }
          ]
        }
      ],
      rows: []
    }
  },
  watch: {
    appliedPriceCodePeriod(data) {
      this.dailyPriceItem.start_date = data.start
      this.dailyPriceItem.end_date = data.end
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  mounted() {
    this.getPriceTypeOptions()
  },
  computed: {
    updatePermit() {
      let output = false
      if (
        this.priceCodeId &&
        this.dailyPriceItem.price_type &&
        this.dailyPriceItem.weekday.length !== 0 &&
        this.dailyPriceItem.start_date &&
        this.dailyPriceItem.end_date
      ) {
        output = true
      }
      return output
    }
  },
  methods: {
    resetAppliedPriceCodeForm() {
      // this.appliedPriceCodePeriod = {}
      // this.dailyPriceItem = {
      //   price_code_id: null,
      //   price_type: null,
      //   start_date: null,
      //   end_date: null,
      //   weekday: []
      // }
    },
    openEditPriceCodeDialog() {
      const gridApi = this.$refs.agGridPriceCode.gridApi
      const row = gridApi.getSelectedRows()[0]
      Object.assign(this.priceCodeDialogItem, row)
      this.isEditPriceCode = true
      this.priceCodeDialogVisible = true
    },
    openAddPriceCodeDialog() {
      this.isEditPriceCode = false
      this.$nullValueInObj(this.priceCodeDialogItem)
      this.priceCodeDialogVisible = true
    },
    openEditPricePerDayDialog() {
      const gridApi = this.$refs.agGrid4.gridApi
      const row = gridApi.getSelectedRows()[0]
      Object.assign(this.pricePerDayDialogItem, row)
      this.isEditPricePerDay = true
      this.priceCodePerDayDialogVisible = true
    },
    openAddPricePerDayDialog() {
      this.$nullValueInObj(this.pricePerDayDialogItem)
      this.isEditPricePerDay = false
      this.priceCodePerDayDialogVisible = true
    },
    async openPriceTypeDialog() {
      await this.getPriceTypeOptions()
      this.dialogPriceConfigVisible = true
    },
    resetInfo() {},
    onChangeDate3(date) {
      if (date) {
        this.pricePerDayDialogItem.date_from =
          this.$moment(date).format('YYYY-MM-DD')
      }
    },
    onChangeDate4(date) {
      if (date) {
        this.pricePerDayDialogItem.date_to =
          this.$moment(date).format('YYYY-MM-DD')
      }
    },
    getDataConfigCode2(id) {
      this.$axios
        .get('/config-service/v1/hotel/price-daily/price-type', {
          params: {
            id: id
          }
        })
        .then(res => {
          this.configTable2Rows = res.data
          this.configTable3Rows = []
          this.isPricePerdayRowSelected = false
        })
    },
    async onAddPricePerDay() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator2)) === false) {
        return
      }
      const gridApi = this.$refs.agGridPriceCode.gridApi
      const row = gridApi.getSelectedRows()[0]
      const data = {
        period_type_id: row.id,
        code: this.pricePerDayDialogItem.code,
        desc: this.pricePerDayDialogItem.desc,
        date_from: this.pricePerDayDialogItem.date_from,
        date_to: this.pricePerDayDialogItem.date_to
      }
      this.$axios
        .post('/config-service/v1/hotel/price-daily/period', data)
        .then(async res => {
          const message = res.message
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.addConfigCode2Visible = true
          // this.isEditConfig2 = false
          this.priceCodePerDayDialogVisible = false
          await this.getDataConfigCode2(row.id)
          this.pricePerDayDialogItem.code = null
          this.pricePerDayDialogItem.desc = null
          this.pricePerDayDialogItem.date_from = null
          this.pricePerDayDialogItem.date_to = null
          // this.configTable3Rows = []
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async onAddPriceCode() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator1)) === false) {
        return
      }
      const data = {
        p_code: 'PRICE_TYPE',
        code: this.priceCodeDialogItem.code,
        desc: this.priceCodeDialogItem.desc
      }
      this.$axios
        .post('/config-service/v1/statistic/code', data)
        .then(async res => {
          const message = res.message
          await this.getPriceTypeOptions()
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.priceCodeDialogItem.code = null
          this.priceCodeDialogItem.desc = null
          this.priceCodeDialogVisible = false
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
      this.addConfigCode1Visible = true
    },
    async onUpdatePriceCode() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator1)) === false) {
        return
      }
      const data = {
        p_code: 'PRICE_TYPE',
        code: this.priceCodeDialogItem.code,
        desc: this.priceCodeDialogItem.desc,
        id: this.priceCodeDialogItem.id
      }
      this.$axios
        .put('/config-service/v1/statistic/code', data)
        .then(async res => {
          await this.getPriceTypeOptions()
          const message = res.message
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.priceCodeDialogVisible = false
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    onChangeDate2(dateFrom, dateTo) {
      this.dailyPriceItem.start_date =
        this.$moment(dateFrom).format('YYYY-MM-DD')
      this.dailyPriceItem.end_date = this.$moment(dateTo).format('YYYY-MM-DD')
    },
    onChangeDate1(dateFrom, dateTo) {
      // dateFrom = this.$moment(dateFrom).format("YYYY-MM-DD");
      // dateTo = this.$moment(dateTo).format("YYYY-MM-DD");
      // if (dateFrom && dateTo && dateFrom > dateTo) {
      //   this.$vxAlert("Thời gian kết thúc phải sau thời gian bắt đầu");
      //   this.formRoomSurcharge.date_to = this.$moment(dateFrom)
      //     .add(1, "d")
      //     .toDate();
      // } else {
      // }
      this.priceCodeItem.startDt = this.$moment(dateFrom).format('YYYY-MM-DD')
      this.priceCodeItem.endDt = this.$moment(dateTo).format('YYYY-MM-DD')
    },
    changeAppliedDay(data) {
      if (data == 0) {
        if (this.allDayApplied) {
          this.dailyPriceItem.weekday = []
          this.allDayApplied = false
        } else {
          this.dailyPriceItem.weekday = [2, 3, 4, 5, 6, 7, 8]
          this.allDayApplied = true
        }
        return
      }
      const idx = this.dailyPriceItem.weekday.indexOf(data)
      if (idx == -1) {
        this.dailyPriceItem.weekday.push(data)
      } else {
        this.dailyPriceItem.weekday.splice(idx, 1)
      }
    },
    getPriceTypeOptions() {
      this.$axios
        .get('/config-service/v1/statistic/code?pCode=PRICE_TYPE')
        .then(res => {
          this.priceTypeOptions = res.data
          this.isPriceCodeRowSelected = false
          this.configTable2Rows = []
          this.configTable3Rows = []
        })
    },
    async updateDailyPrice() {
      // if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
      //   return
      // }
      // if (this.dailyPriceItem.weekday.length === 0) {
      //   this.$message({
      //     message: 'Ngày áp dụng trong tuần bắt buộc phải nhập',
      //     type: 'error'
      //   })
      //   return
      // }
      this.dailyPriceItem.price_code_id = this.priceCodeId
      this.$axios
        .put('/config-service/v1/hotel/price-daily', this.dailyPriceItem)
        .then(async res => {
          const message = res.message
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.resetAppliedPriceCodeForm()
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    onRefresh() {},
    changeCurrencyInput(params, value) {
      const gridApi = this.$refs.agGrid4.gridApi
      const rowsSelected = gridApi.getSelectedRows()[0]
      this.configTable3Loading = true
      this.configTable3Loading = false
      this.configTable3Rows[params.rowIndex][params.column.colId] = value
      const data = {
        price_daily_per_room_list: this.configTable3Rows,
        price_type_period_id: rowsSelected.id
      }
      this.$axios
        .put('/config-service/v1/hotel/price-daily/price-per-room', data)
        .then(async res => {
          const message = res.message
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    // textInputChange(params, value) {
    //   const gridApi = this.$refs.agGrid4.gridApi
    //   const rowsSelected = gridApi.getSelectedRows()[0]
    //   this.configTable3Loading = true
    //   this.configTable3Loading = false
    //   this.configTable3Rows[params.rowIndex][params.column.colId] = value
    //   const data = {
    //     price_daily_per_room_list: this.configTable3Rows,
    //     price_type_period_id: rowsSelected.id
    //   }
    //   this.$axios
    //     .put('/config-service/v1/hotel/price-daily/price-per-room', data)
    //     .then(async res => {
    //       const message = res.message
    //       this.$message({
    //         type: 'success',
    //         message: this.$t(`successMsg.${message}`)
    //       })
    //     })
    //     .catch(error => {
    //       const message = error.response?.data?.message || 'default'
    //       this.$message({
    //         type: 'error',
    //         message: this.$t(`errorMsg.${message}`)
    //       })
    //     })
    // },
    onAddConfigCode1() {
      this.priceCodeDialogItem.code = null
      this.priceCodeDialogItem.desc = null
      this.addConfigCode1Visible = false
      this.isEditConfig1 = true
    },
    onAddConfigCode2() {
      const gridApi = this.$refs.agGridPriceCode.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          message: this.$t('errorMsg.selectPriceTypeError'),
          type: 'error'
        })
        return
      }
      this.pricePerDayDialogItem.code = null
      this.pricePerDayDialogItem.desc = null
      this.pricePerDayDialogItem.date_from = null
      this.pricePerDayDialogItem.date_to = null
      this.isEditConfig1 = true
      this.addConfigCode2Visible = false
    },
    async onUpdatePricePerDay() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator2)) === false) {
        return
      }
      const gridApi1 = this.$refs.agGridPriceCode.gridApi
      const row1 = gridApi1.getSelectedRows()[0]
      const gridApi2 = this.$refs.agGrid4.gridApi
      const row2 = gridApi2.getSelectedRows()[0]
      const data = {
        id: row2.id,
        // id cua parent
        period_type_id: row1.id,
        code: this.pricePerDayDialogItem.code,
        desc: this.pricePerDayDialogItem.desc,
        date_from: this.pricePerDayDialogItem.date_from,
        date_to: this.pricePerDayDialogItem.date_to
      }
      this.$axios
        .put('/config-service/v1/hotel/price-daily/period', data)
        .then(async res => {
          const message = res.message
          await this.getDataConfigCode2(row1.id)
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.priceCodePerDayDialogVisible = false
          this.pricePerDayDialogItem.code = null
          this.pricePerDayDialogItem.desc = null
          this.pricePerDayDialogItem.date_from = null
          this.pricePerDayDialogItem.date_to = null
          this.configTable3Rows = []
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    onPriceCodeRowClicked(params) {
      this.isPriceCodeRowSelected = true
      this.isPricePerdayRowSelected = false
      const id = params[0].id
      this.configTable3Rows = []
      // this.addConfigCode1Visible = true
      // Object.assign(this.priceCodeDialogItem, params[0])
      // this.pricePerDayDialogItem.code = null
      // this.pricePerDayDialogItem.desc = null
      // this.pricePerDayDialogItem.date_from = null
      // this.pricePerDayDialogItem.date_to = null
      this.$axios
        .get('/config-service/v1/hotel/price-daily/price-type', {
          params: {
            id: id
          }
        })
        .then(res => {
          this.configTable2Rows = res.data
          if (this.configTable2Rows.length > 0) {
            const gridApi = this.$refs.agGrid4.gridApi
            const rowsSelected = gridApi.getSelectedRows()[0]
            Object.assign(this.pricePerDayDialogItem, rowsSelected)
          }
        })
    },
    onPricePerDayRowClicked(params) {
      this.isPricePerdayRowSelected = true
      const gridApi = this.$refs.agGrid4.gridApi
      const id = gridApi.getSelectedRows()[0].id
      // Object.assign(this.pricePerDayDialogItem, params[0])
      // this.addConfigCode2Visible = true
      this.$axios
        .get('/config-service/v1/hotel/price-daily/period/detail', {
          params: {
            id: id
          }
        })
        .then(res => {
          this.configTable3Rows = res.data
        })
    },
    async onDisplayPriceList(params) {
      this.priceCodeId = params.id
      this.rows = []
      const data = {
        priceCodeId: params.id,
        startDate: params.startDt,
        endDate: params.endDt
      }
      this.$axios
        .get('/config-service/v1/hotel/price-daily', {
          params: data
        })
        .then(res => {
          const response = res.data
          // const treckData = response[0]
          const roomLevel = response[0].price_daily_per_room_level.map(item => {
            return {
              name: item.room_level_nm,
              code1: item.room_level_nm_without_space + '_single_guest',
              code2: item.room_level_nm_without_space + '_double_guest',
              code3: item.room_level_nm_without_space + '_extra_guest'
            }
          })
          let addedColumns = roomLevel.map(item => {
            return {
              headerName: item.name,
              field: 'abc',
              cellClass: 'grid-cell-centered',
              headerClass: [
                'header-cell-suffix-group',
                'header-group-cell-divide',
                'header-cell-center'
              ],
              children: [
                {
                  headerName: 'Khách',
                  field: item.code1,
                  headerClass: 'header-cell-center',
                  cellClass: 'grid-cell-centered'
                  // maxWidth: 100
                }
                // {
                //   headerName: 'Khách đôi',
                //   field: item.code2,
                //   cellClass: 'grid-cell-centered',
                //   maxWidth: 100
                // },
                // {
                //   headerName: 'Giường phụ',
                //   field: item.code3,
                //   cellClass: 'grid-cell-centered',
                //   maxWidth: 100
                // }
              ]
            }
          })
          // Columns
          this.columns = []
          this.columns = [...this.fixedColumns, ...addedColumns]
          // rows
          const addedRows = []
          response.map(item => {
            let obj = {}
            obj.date = item.date
            obj.price_type_nm = item.price_type_nm
            item.price_daily_per_room_level.map(item2 => {
              const keyNm1 = item2.room_level_nm_without_space + '_single_guest'
              const keyNm2 = item2.room_level_nm_without_space + '_double_guest'
              const keyNm3 = item2.room_level_nm_without_space + '_extra_guest'
              obj[keyNm1] = item2.single_guest
              obj[keyNm2] = item2.double_guest
              obj[keyNm3] = item2.extra_guest
            })
            addedRows.push(obj)
          })

          this.rows = addedRows
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.border-box {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dedfe7;
  border-radius: 5px;
}
</style>
